import React from "react";
import PropTypes from "prop-types";

const ArrowBentIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  flipHorizontally,
  disabled,
  title
}) => {
  const wrapperStyle = {
    width: width || size || 20,
    height: height || size || 20
  };

  const finalStyle = {
    transform: `scaleX(${flipHorizontally ? -1 : 1})`,
    opacity: disabled ? 0.3 : 1,
    display: "block",
    ...style
  };

  const strokeColor = color || "#57595D";

  return (
    <div style={wrapperStyle}>
      <svg
        className={className}
        style={finalStyle}
        data-no-pointer={noPointer}
        width={width || size || 20}
        height={height || size || 20}
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby={title ? "title" : undefined}
      >
        {title && <title>{title}</title>}
        <g fill="none" fillRule="evenodd">
          <path
            d="M12 17H8.5a5.5 5.5 0 0 1 0-11H17"
            stroke={strokeColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="m14 2 4 4-4 4"
            stroke={strokeColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </div>
  );
};

ArrowBentIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string,
  flipHorizontally: PropTypes.bool,
  disabled: PropTypes.bool,
  noPointer: PropTypes.bool,
  title: PropTypes.string
};

export default ArrowBentIcon;
